/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import { IDescriptorBody } from '../../../descriptor';
import PackageDataMessage, { IPackageDataMessage } from './packagedatamessage';

import ParserUtils, { MessageDataTypes } from './../parserutils';

export interface IObjectBufferPacketDataMessage extends IPackageDataMessage {
	data?: string;
	data1: Buffer;
}

export default class ObjectBufferPacketDataMessage extends PackageDataMessage {
	public static readonly TYPE: number =
		/* #__PURE__ -- @preserve */ ( () => ParserUtils.getPacketType( MessageDataTypes.OBJECT, MessageDataTypes.BUFFER ) )();

	public static readonly DESCRIPTOR_NAME: string = 'ObjectBufferPacketDataMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = /* #__PURE__ -- @preserve */ ( () => ( {
		fields: {
			data: {
				type: 'string',
				id: 1
			},
			data1: {
				type: 'bytes',
				id: 2
			}
		}
	} ) )();

	public constructor( public readonly data: Record<string, unknown>, public readonly data1: Buffer ) {
		super();
	}

	public toJSON(): IObjectBufferPacketDataMessage {
		return {
			data: this.data ? JSON.stringify( this.data ) : undefined,
			data1: this.data1
		};
	}

	public static fromJSON( data: IObjectBufferPacketDataMessage ): ObjectBufferPacketDataMessage {
		return new ObjectBufferPacketDataMessage( data.data && JSON.parse( data.data ), data.data1 );
	}

	public static create( data: Record<string, unknown>, data1: Buffer ): ObjectBufferPacketDataMessage {
		return new ObjectBufferPacketDataMessage( data, data1 );
	}
}
